<template>
  <v-btn
    v-if="toolBarStatus === 'edit'"
    class="my-2"
    color="primary"
    depressed
    block
    small
    @click="savePost"
  >
    <span class="font-weight-bold">{{ saveBtnTxt }}</span>
  </v-btn>
  <v-btn
    v-else-if="toolBarStatus === 'comment'"
    color="primary"
    depressed
    block
    @click="savePost"
  >
    <span class="font-weight-bold">{{ saveBtnTxt }}</span>
  </v-btn>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    orderId: {
      type: Number,
      required: false,
      default: null
    },
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      toolBarStatus: (state) => state.PostEditor.toolBarStatus
    }),
    saveBtnTxt () {
      if (this.post.status === 'draft') {
        if (this.toolBarStatus === 'comment') {
          return '下書き保存'
        } else {
          return '下書き保存する'
        }
      } else {
        return '更新する'
      }
    }
  },
  methods: {
    savePost () {
      this.$store.dispatch('PostEditor/updatePost')
    }
  }
}
</script>
